import { Skeleton } from '@vimeo/bokeh';
import { Navigation } from '@vimeo/navigation';

export const NavLoader = () => (
  <Navigation>
    <Navigation.LeftContent>
      <Skeleton borderRadius="sm" w="80px" h="30px" />
    </Navigation.LeftContent>
    <Navigation.RightContent>
      <Skeleton borderRadius="button" w="92px" h="40px" />
      <Skeleton borderRadius="full" w="40px" h="40px" />
    </Navigation.RightContent>
  </Navigation>
);
